import store from '@apply/adminStore';
import { LoanActionType } from '../LoanConstants';
import { executeLoanAction } from './executeLoanAction';
import { Location } from 'react-router';

export const OnOpenLoanSummary = (e, location: Location) => {
    const { dispatch } = store;
    if (e.rowType !== 'data' || e.column.type === 'detailExpand' || e.column.type === 'actions') {
        return;
    }

    var model = {
        id: LoanActionType.Summary,
        loanId: e.data.id,
    };
    executeLoanAction(model, dispatch, location, false);
};
